<mat-form-field
  class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50"
>
  <!-- TIPOS DE ENTRADAS -->
  <input
    matInput
    type="text"
    [disabled]="filtros.length <= 0"
    [placeholder]="'Busca avançada'"
    [(ngModel)]="termoPesquisa"
    #termo
    (keyup.enter)="adicionarFiltro()"
    [autocomplete]="'off'"
    *ngIf="mostrarInputText"
  />

  <input
    matInput
    type="number"
    [disabled]="filtros.length <= 0"
    [placeholder]="'Busca avançada'"
    [(ngModel)]="termoPesquisa"
    #termo
    (keyup.enter)="adicionarFiltro()"
    [autocomplete]="'off'"
    *ngIf="mostrarInputNumer"
  />

  <ng-container *ngIf="mostrarInputData">
    <input
      matInput
      [(ngModel)]="termoPesquisa"
      [matDatepicker]="data_pesquisa"
      (keyup.enter)="adicionarFiltro()"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="data_pesquisa"
    ></mat-datepicker-toggle>
    <mat-datepicker #data_pesquisa></mat-datepicker>
  </ng-container>

  <ng-container *ngIf="mostrarInputRange">
    <mat-date-range-input
      [rangePicker]="periodo_data"
      (keyup.enter)="adicionarFiltro()"
    >
      <input matStartDate placeholder="Data Início" [(ngModel)]="data_inicio" />
      <input matEndDate placeholder="Data Fim" [(ngModel)]="data_fim" />
    </mat-date-range-input>
    <mat-datepicker-toggle
      matIconSuffix
      [for]="periodo_data"
    ></mat-datepicker-toggle>
    <mat-date-range-picker #periodo_data></mat-date-range-picker>
  </ng-container>

  <ng-container *ngIf="mostrarEnum">
    <!-- input nessesário para separar os dois selects -->
    <input matInput type="text" [hidden]="true" />
    <mat-select
      [(ngModel)]="termoPesquisa"
      (selectionChange)="adicionarFiltro()"
    >
      <mat-option *ngFor="let item of dadosEnum" [value]="item">{{
        item.texto
      }}</mat-option>
    </mat-select>
  </ng-container>

  <!-- SELECT PREFIX -->
  <mat-select
    [value]="1"
    [(ngModel)]="tipoSelecionado"
    (selectionChange)="mostrarInput()"
    matPrefix
    *ngIf="filtros.length > 0"
  >
    <mat-option *ngFor="let item of filtros" [value]="item.codigo">{{
      item.nome
    }}</mat-option>
  </mat-select>
</mat-form-field>

<div *ngIf="filtrosSelecionados.length > 0">
  <div class="flex flex-wrap items-center mt-2">
    <ng-container *ngFor="let item of filtrosSelecionados">
      <div
        class="flex items-center justify-center py-1 px-3 mr-3 mb-3 rounded-full leading-normal text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700"
      >
        <span class="text-sm font-medium whitespace-nowrap flex justify-center">
          <p>{{ item.nome }}: {{ item?.valorMostrar }}</p>
          <mat-icon
            class="ml-1 icon-size-4 cursor-pointer"
            svgIcon="heroicons_outline:x-mark"
            (click)="removerFiltro(item.codigo)"
          ></mat-icon>
        </span>
      </div>
    </ng-container>
  </div>
</div>
